import { createInertiaApp } from "@inertiajs/react";
import type { ComponentType, ReactNode } from "react";

import AppLayout from "@/layouts/AppLayout";

type PageModule = {
  default: ComponentType & { layout?: (page: ReactNode) => ReactNode };
};

void createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob<PageModule>("../pages/**/*.tsx", {
      eager: true,
    });
    const page = pages[`../pages/${name}.tsx`];
    if (!page) {
      throw new Error(`Inertia page not found: ${name} (../pages/${name}.tsx)`);
    }
    // Default persistent layout; a page can opt out with `Page.layout = null`.
    page.default.layout ??= (p: ReactNode) => <AppLayout>{p}</AppLayout>;
    return page;
  },

  strictMode: true,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" };
    },
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (document.getElementById("app")) {
    throw error;
  } else {
    console.error(
      "Missing root element.\n\n" +
        "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
        'Consider moving <%= vite_typescript_tag "inertia.tsx" %> to the Inertia-specific layout instead.',
    );
  }
});
